import React, { createContext, useState } from 'react';
// Contextの作成
export const ModeContext = createContext();

// Context Providerの作成
export const ModeProvider = ({ children }) => {
    const [mode, setMode] = useState('');
    const [messages, setMessages] = useState([]); // メッセージの状態を追加
    const [sessionId, setSessionId] = useState(null); // セッションID
    const [chatHistory, setChatHistory] = useState([]);// チャット履歴
    const [isComplete, setIsComplete] = useState(true);
    const [isUploadMode, setIsUploadMode] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState([]);
    const [fileList,setFileList] = useState([]);
    const [activeButton, setActiveButton] = useState('chat');
    const [user, setUser] = useState(''); // ログインユーザー
    const [isComponentAVisible, setIsComponentAVisible] = useState(true);
    const [activeAdminComponent, setActiveAdminComponent] = useState('');
    const [loginInfo, setLoginInfo] = useState({});
    const [dataset, setDataset] = useState({});
    const [ input, setInput] = useState('');
    const [ filebuList,setFilebuList] = useState('');
    const [displayMode, setDisplayMode] = useState('chat'); // 'chat' or 'request'    
    const [requestStatusFilter, setRequestStatusFilter] = useState(''); // 状態フィルター
    const [requestStatusCounts, setRequestStatusCounts] = useState({}); // 状態ごとの件数
    const [faqList, setFaqList] = useState([]); // FAQ一覧
    const [unreadCommentCount, setUnreadCommentCount] = useState(0); // 未読コメント数
    const [currentRequestNumber, setCurrentRequestNumber] = useState(null); // 現在の受付番号



    return (
        <ModeContext.Provider value={{
            isUploadMode, setIsUploadMode, 
            mode, setMode, 
            messages, setMessages,
            sessionId, setSessionId,
            chatHistory, setChatHistory,
            isComplete, setIsComplete,
            selectedFiles, setSelectedFiles,
            selectedFile, setSelectedFile,
            fileList,setFileList,
            activeButton, setActiveButton,
            user, setUser,
            isComponentAVisible, setIsComponentAVisible,
            activeAdminComponent, setActiveAdminComponent,
            loginInfo,setLoginInfo,
            dataset, setDataset,
            input, setInput,
            filebuList,setFilebuList,
            displayMode, setDisplayMode,
            requestStatusFilter, setRequestStatusFilter,
            requestStatusCounts, setRequestStatusCounts,
            faqList, setFaqList,
            unreadCommentCount, setUnreadCommentCount,
            currentRequestNumber, setCurrentRequestNumber
            }}>
            {children}
        </ModeContext.Provider>
    );
};

